import { useMemo } from "react";
import { Info } from "@phosphor-icons/react";

// Tri-lingual estimate note shown on client-facing surfaces.
// Language is resolved from (in order):
//   1) explicit `lang` prop ("fr" | "en" | "es")
//   2) browser navigator.language
//   3) fallback "fr"
const MESSAGES = {
  fr: {
    label: "Estimation",
    text: "Estimation du tarif basée sur votre trajet. Nous vous enverrons une proposition définitive, adaptée à votre demande, dans les plus brefs délais.",
  },
  en: {
    label: "Estimate",
    text: "Estimated fare based on your trip. We will send you a final personalized offer tailored to your request shortly.",
  },
  es: {
    label: "Estimación",
    text: "Tarifa estimada basada en su trayecto. Le enviaremos una propuesta final personalizada adaptada a su solicitud en breve.",
  },
};

function resolveLang(lang) {
  if (lang && MESSAGES[lang]) return lang;
  if (typeof navigator !== "undefined" && navigator.language) {
    const code = navigator.language.slice(0, 2).toLowerCase();
    if (MESSAGES[code]) return code;
  }
  return "fr";
}

export default function PriceEstimateNote({ lang, price, currency = "EUR", source, className = "" }) {
  const l = useMemo(() => resolveLang(lang), [lang]);
  const m = MESSAGES[l];
  return (
    <div
      data-testid="price-estimate-note"
      data-lang={l}
      className={`rounded-lg border border-amber-500/30 bg-amber-500/5 p-3 ${className}`}
    >
      {price != null && (
        <div className="flex items-baseline justify-between gap-3 mb-1.5">
          <span className="text-[11px] uppercase tracking-wider text-amber-400/80 font-medium">{m.label}</span>
          <span data-testid="price-estimate-value" className="text-xl font-semibold text-amber-400">
            {Number(price).toFixed(2).replace(/\.00$/, "")} {currency}
          </span>
        </div>
      )}
      <p className="flex gap-2 text-[12px] leading-relaxed text-zinc-300">
        <Info size={14} weight="fill" className="text-amber-400 shrink-0 mt-0.5" />
        <span>{m.text}</span>
      </p>
      {source === "distance" && (
        <p className="mt-1 text-[10px] text-zinc-500 uppercase tracking-wider">
          {l === "fr" ? "Calcul à la distance" : l === "es" ? "Cálculo por distancia" : "Distance-based"}
        </p>
      )}
    </div>
  );
}
